<template>
    <div
        class="caculator-container broker"
        :class="info.nodisclosureDes != null ? 'nodisclosure' : ''"
        v-outsideclick="hideCaculator"
        v-outsidetouchstart="hideCaculator"
    >
        <div v-if="!info.pricePerMonth" @click.stop="caculatorHandler">
            <span class="iconfont icon-caculator">
                <span class="payment-text">{{
                    $t('md-detail-info.estPayment')
                }}</span>
            </span>
            <span class="split-line">|</span>
            <label>
                {{
                    $ft.formatCurrency({
                        value: info.nodisclosureDes != null ? '-' : pricePerMonth,
                        noSpace: true,
                        currencySymbol
                    })
                }} </label
            >{{ $t('md-detail-info.mo')
            }}<CalculatorBroker
                v-if="caculatorOptions && !isMobileSize"
                v-bind="caculatorOptions"
                @close="hideCaculator"
            />
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { defineAsyncComponent } from 'vue';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['openCaculator'],
    data: function() {
        return {
            caculatorOptions: null
        };
    },
    components: {
        CalculatorBroker: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "common/calculator/broker"*/ '@/components/caculator/broker.vue'
            ))
    },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "pricePerMonth": store => store.pricePerMonth,
            "info": store => store.listingDetail.info || {}
        }),
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.house.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
        
    },
    methods: {
        async caculatorHandler() {
            let open = false;
            if (this.isMobileSize) {
                open = true;
                this.openCaculator('broker', open);
                return;
            }
            let option = await this.openCaculator('broker', open);
            this.caculatorOptions = Object.assign(option, { options: {} });
        },
        hideCaculator() {
            this.caculatorOptions = null;
        }
    }
};
</script>
<style lang="scss">
.caculator-container:hover {
    background: #dedede;
}
.broker.caculator-container {
    cursor: pointer;
    display: inline-block;
    padding: 10px 5px 10px 10px;
    border-radius: 5px;
    border: solid 1px #dedede;
    background-color: #ffffff;
    color: #505050;
    margin-top: 15px;
    font-size: 12px;
    position: relative;
    .caculator-broker {
        position: absolute;
        left: 0;
        top: 44px;
        z-index: 3;
        &:before {
            content: '';
            border: 6px solid var(--color-theme);
            border-top-color: transparent;
            border-left-color: transparent;
            border-right-color: transparent;
            position: absolute;
            top: -16px;
            left: 12px;
        }
    }
    @media (max-width: 600px) {
        margin-top: 0;
        .icon-caculator {
            max-width: fit-content !important;
        }
    }
    & > div {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    &.nodisclosure {
        opacity: 0.4;
        .icon-caculator {
            cursor: initial;
            color: #505050;
        }
    }
    .split-line {
        margin: 0 5px;
    }
    label {
        padding-right: 2px;
        cursor: pointer;
    }
    .cal {
        margin-left: 15px;
        font-size: 12px;
        cursor: pointer;
    }
    .icon-caculator {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        max-width: 115px;
        cursor: pointer;
        .payment-text {
            font-size: 12px;
            margin-left: 5px;
        }
    }
}
</style>
